import { z } from 'zod';
import { HstTreatmentSchema, RateModifierApplyToSchema, RateModifierFormulaSchema, ShiftSettingSchema, ShiftTimeBucketSchema, } from '../rate/enums.schema.js';
import { ShiftStatusSchema } from './enums.schema.js';
// The Shift snapshot payload. modifiersApplied mirrors the
// RateService.resolveRate output payload from Phase 8b (8b-5 lock —
// engine output IS the snapshot contract). hstTreatment + the bucket
// + isStatHoliday come along for downstream billing + reporting.
const RateSnapshotModifierSchema = z.object({
    code: z.string(),
    applyTo: RateModifierApplyToSchema,
    formula: RateModifierFormulaSchema,
    amount: z.string(), // Decimal serialized as string
});
export const ShiftResponseSchema = z.object({
    id: z.string().uuid(),
    shiftRequestId: z.string().uuid(),
    caregiverId: z.string().uuid(),
    roleId: z.string().uuid(),
    setting: ShiftSettingSchema,
    scheduledStart: z.string().datetime(),
    scheduledEnd: z.string().datetime(),
    status: ShiftStatusSchema,
    // Rate snapshot
    payRateAtBooking: z.string(),
    billRateAtBooking: z.string(),
    hstTreatmentAtBooking: HstTreatmentSchema,
    modifiersApplied: z.array(RateSnapshotModifierSchema),
    shiftTimeBucketAtBooking: ShiftTimeBucketSchema,
    isStatHolidayAtBooking: z.boolean(),
    facilityBillRateOverrideApplied: z.boolean(),
    // Service-address snapshot (homecare only — NULL for LTC)
    serviceAddressLine1AtBooking: z.string().nullable(),
    serviceAddressLine2AtBooking: z.string().nullable(),
    serviceAddressCityAtBooking: z.string().nullable(),
    serviceAddressProvinceAtBooking: z.string().nullable(),
    serviceAddressPostalCodeAtBooking: z.string().nullable(),
    serviceAddressGeocodeLatAtBooking: z.string().nullable(),
    serviceAddressGeocodeLngAtBooking: z.string().nullable(),
    acceptedViaManualAssign: z.boolean(),
    actualStart: z.string().datetime().nullable(),
    actualEnd: z.string().datetime().nullable(),
    hoursActual: z.string().nullable(),
    completionNotes: z.string().nullable(),
    completedAt: z.string().datetime().nullable(),
    completedByUserId: z.string().uuid().nullable(),
    invoiceLineId: z.string().uuid().nullable(),
    payoutLineId: z.string().uuid().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ShiftListResponseSchema = z.object({
    items: z.array(ShiftResponseSchema),
    totalCount: z.number().int().min(0),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
});
export const CompleteShiftRequestSchema = z.object({
    actualStart: z.string().datetime(),
    actualEnd: z.string().datetime(),
    completionNotes: z.string().max(2000).optional(), // non-clinical
});
export const CancelShiftSchema = z.object({
    reason: z.string().min(10).max(500),
});
//# sourceMappingURL=shift.schema.js.map